<span *ngIf="this.appData.selectedComapnyId !== undefined">
<b>{{eduSys.name}} &nbsp; &nbsp;{{eduSys.registrationNo}}</b>
<button mat-button color="primary" (click)="createIndividualMember()">Create
		Members/Staff</button>
</span>


<div class="col-md-12">
	<table class="table table-responsive table-hover">
		<tr>
			<th>User Id</th>
			<th class="divider-vertical-header-full-height">Name</th>
			<th class="divider-vertical-header-full-height">Last Name</th>
			<th class="divider-vertical-header-full-height">Individual Type</th>
			<th class="divider-vertical-header-full-height">Status</th>
			<th class="divider-vertical-header-full-height">View Test Result</th>
		</tr>
		<tr *ngFor="let item of records">
			<td>{{item.loginUserId}}</td>
			<td class="divider-vertical-data-full-height">{{item.firstName}} {{item.middleName}}</td>
			<td class="divider-vertical-data-full-height">{{item.lastName}}</td>
			<td class="divider-vertical-data-full-height">{{item.individualType}}</td>
			<td class="divider-vertical-data-full-height">{{item.status}}</td>
			
			
			<td class="divider-vertical-data-full-height"><span *ngIf="this.appData.availablePrivileges.value.VIEW_OTHERS_TEST || this.appData.availablePrivileges.value.VIEW_OTHERS_TEST_WITH_RESULT">
				<!--<a [routerLink]="['/dashboard-test-series',{'p':'x', 'u':item.loginUserId}]">-->
				<!--<a (click)="testResultHistory(item.loginUserId)">-->
				<a (click)="testResultHistoryDetail(item.loginUserId)">
				<button mat-button>
					<mat-icon>remove_red_eye</mat-icon>
				</button>
				</a>
				</span>&nbsp;
			</td>
			
		</tr>
	</table>
</div>